import React from "react";
import HomePage from "../HomePage";
import Card from "../Card";
import HigherLower from "../HigherLower";
import Footer from "../Footer";

function Home() {
  return (
    <>
      <HomePage />
      <HigherLower />
      <Card />
      <Footer />
    </>
  );
}

export default Home;
